export enum Reportable {
  OPPORTUNITY = 'App\\Models\\Opportunity',
}
